module.exports = __webpack_public_path__ + "img/Backyard-paws-Typography.439b5212.webp";